import { render, staticRenderFns } from "./jt-whatsapp.vue?vue&type=template&id=033640a6&scoped=true"
import script from "./jt-whatsapp.vue?vue&type=script&lang=js"
export * from "./jt-whatsapp.vue?vue&type=script&lang=js"
import style0 from "./jt-whatsapp.vue?vue&type=style&index=0&id=033640a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033640a6",
  null
  
)

export default component.exports